import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { DatetimePickerComponent } from '../../../../../../shared/components/datetime-picker/datetime-picker.component';
import { toDateString } from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';

@Component({
	selector: 'app-vehicles-purchase-details',
	templateUrl: 'vehicles-purchase-details.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SectionWrapperComponent,
		DatetimePickerComponent,
	],
})
export class VehiclesPurchaseDetailsComponent
	extends BaseSectionComponent<VehicleRecordModel>
	implements OnInit
{
	protected _skipCount: number = 0;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			purchasedAt: [null],
			purchaseListPrice: [null],
			purchasePaidPrice: [null],
		});
	}

	onPurchaseAtReset() {
		this.detailsForm.controls.purchasedAt.reset();
		this.detailsForm.updateValueAndValidity();
		this.sectionChanged.emit(this._mapFormToModel());
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			purchasedAt: toDateString(this.recordData().purchasedAt),
			purchaseListPrice: this.recordData().purchaseListPrice,
			purchasePaidPrice: this.recordData().purchasePaidPrice,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			purchasedAt: this.detailsForm.value.purchasedAt,
			purchaseListPrice: this.detailsForm.value.purchaseListPrice,
			purchasePaidPrice: this.detailsForm.value.purchasePaidPrice,
		};
	}
}
